// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2fhnv","productName":"Table_productName__kLGvQ"};